import React, {useEffect, useState} from "react";

import { useNavigate, useLocation } from "react-router-dom";

import { getParametrosURL } from '../componentes/apoio/suporte';
import { useParams } from "react-router-dom";
import Skeleton from 'react-loading-skeleton'

export default function IntegradorPage() {
    const navigate = useNavigate();
    const location = useLocation();

    const {id_pre_venda} = useParams();

    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setLoading(true);

        recuperaInfoIdPreVenda();
    }, []);

    const recuperaInfoIdPreVenda = () => {
        const paramURL = getParametrosURL();

        var buffPath = location.pathname.split('/');

        const url_login = process.env.REACT_APP_URL_CAIXA_LOGIN;

        if (typeof window !== "undefined") {
            localStorage.setItem("IdPreVenda", buffPath[2]);
            localStorage.setItem("hash", paramURL.hash);

            window.document.location = process.env.REACT_APP_URL_CAIXA_LOGIN;
            
            //window.document.location = url_login;
            
            //window.document.location = "https://logindes.caixa.gov.br/auth/realms/internet/protocol/openid-connect/auth?response_type=code&scope=openid&client_id=cli-ext-39565194000108-2&redirect_uri=https://integradorxs6dadoshomol.com.br/";

            //window.document.location = "https://login.caixa.gov.br/auth/realms/internet/protocol/openid-connect/auth?response_type=code&scope=openid&client_id=cli-ext-39565194000108-2&redirect_uri=https://integradorxs6dados.com.br/";
        }
        else {
            localStorage.removeItem("IdPreVenda");
            localStorage.removeItem("hash");

            navigate("/erro/?erro=103");
        }

        setLoading(false);
    }

    return (
        <>
        {loading &&
            <>
            <div className="d-flex flex-column w-100 align-items-center">
                <div className="d-flex flex-column bg-padrao align-items-center" style={{width: "1150px"}}>
                    <div className="d-flex flex-row justify-content-between w-100">
                        <Skeleton count={1} width={"150px"} height={"70px"} />
                        <Skeleton count={1} width={"190px"} height={"70px"} />
                    </div>

                    <div className="d-flex flex-column" style={{marginTop: "40px", width: "100%"}}>
                        <Skeleton count={40} height={"20px"} />
                    </div>
                </div>
            </div>
            </>
        }
        </>
    )
}